"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const victory_1 = require("victory");
const util_shared_styles_1 = require("@atlaskit/util-shared-styles");
class LineChart extends React.Component {
    render() {
        const { data, lineType, color, setLabel } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement(victory_1.VictoryLine, Object.assign({}, this.props, { style: {
                    data: {
                        stroke: color,
                        strokeWidth: "3",
                        strokeDasharray: lineType === "dashed" ? 5 : 0
                    }
                }, data: data })),
            React.createElement(victory_1.VictoryScatter, Object.assign({}, this.props, { style: {
                    data: {
                        fill: "white",
                        stroke: color,
                        strokeWidth: "3"
                    }
                }, symbol: "circle", data: data, size: 3, labels: setLabel, labelComponent: React.createElement(victory_1.VictoryTooltip, null) }))));
    }
}
exports.LineChart = LineChart;
LineChart.role = "line";
LineChart.defaultProps = {
    lineType: "solid",
    color: util_shared_styles_1.akColorB200,
    setLabel: ({ datum }) => "(" + datum.x + ", " + datum.y + ")"
};
